const getTld = hostname => {
  if (!hostname) return null;

  const index = hostname.lastIndexOf('.');
  if (index === -1) return null;

  return hostname.substr(hostname.lastIndexOf('.') + 1);
};

export default getTld;
